"use client";

import { forwardRef } from "react";

const ButtonCookieSettings = forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<"button">
>(({ onClick, ...props }, ref) => {
  return (
    <button
      {...props}
      type="button"
      onClick={(event) => {
        window.OneTrust.ToggleInfoDisplay();
        onClick?.(event);
      }}
      ref={ref}
    >
      Cookie Settings
    </button>
  );
});

ButtonCookieSettings.displayName = "ButtonCookieSettings";

export { ButtonCookieSettings };
